import api from './api';

export async function getProfile() {
  const response = await api.get('/admin/profile');
  return response.data;
}

export async function updateProfile(profile) {
  const response = await api.patch('/admin/profile', profile);
  return response.data;
}
